import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/translation.json';
import { DefaultLng } from './utils/helper.type';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: DefaultLng.ENGLISH,
    debug: false,
    resources: {
      en: { translation: enTranslation },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
